import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { chargesListTypes } from './actionTypes';
import { getChargesListFail, getChargesListSuccess } from './actions';


export const fetchList = async (guid: any) => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

        const query = `query {
        getChargesById(operationGUID: "${guid}", clientId: ${user.EMPRESA_ID}) {
            Type
            OperationGUID
            TaxAmountInCurrency
            ChargeDefinition_Code
            Quantity
            ChargeDefinition_Description
            PriceInCurrency
            Units
            TaxDefinition_Code
            clientId
        }
    }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    return response.data.getChargesById;
};

function* fetchListSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchList, data.payload);
        yield put(getChargesListSuccess(response));
    } catch (error) {
        yield put(getChargesListFail(error));
    }
}


function* chargesListSaga() {
    yield takeLatest(chargesListTypes.GET_CHARGESLIST, fetchListSaga);
}

export default chargesListSaga;
